<template>
  <table class="suspected-players-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">
          <input type="checkbox" v-model="allSelected" class="mr-2">
          Ид
        </th>
        <th scope="col">Имя</th>
        <th scope="col" class="text-right">Монеты</th>
        <th scope="col" class="text-right">Звезды</th>
        <th scope="col">Доступ к событиям</th>
        <th scope="col">Последний вход</th>
        <th scope="col">Подозрительная активность</th>
        <th scope="col" v-if="mayBanPlayer">Действия</th>
      </tr>
    </thead>
    <tr
      v-for="suspectedPlayerContainer in suspectedPlayerContainers"
      :key="suspectedPlayerContainer.player.id"
    >
      <td>
        <input type="checkbox" v-model="suspectedPlayerContainer.selected" class="mr-2">
        <player-link :playerId="suspectedPlayerContainer.player.id" label=""/>
      </td>
      <td>
        {{suspectedPlayerContainer.player.name}}
      </td>
      <td class="text-right">
        {{suspectedPlayerContainer.player.money | getFormattedNumber}}
      </td>
      <td class="text-right">
        {{suspectedPlayerContainer.player.starAmount | getFormattedNumber}}
      </td>
      <td :class="getEventAccessStatusClass(suspectedPlayerContainer.player.eventAccessStatus)">
        {{suspectedPlayerContainer.player.eventAccessStatus | getEventAccessStatusName}}
      </td>
      <td>
        {{suspectedPlayerContainer.player.lastLoginTime | getMomentStr}}
      </td>
      <td>
        <suspicious-activity-list
          :activities="convertSuspiciousActivityMaskToList(suspectedPlayerContainer.player.suspicionsMask)"
        />
      </td>
      <td v-if="mayBanPlayer" class="action-box">
        <b-button
          @click="banPlayer(suspectedPlayerContainer.player.id)"
          variant="danger"
          size="sm"
        >
          Заблокировать
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import { convertSuspiciousActivityMaskToList } from '../model/player.js';

import { getEventAccessStatusNameRu as getEventAccessStatusName      } from '../model/event_access.js';
import { getEventAccessStatusClass                                   } from '../model/event_access.js';

import PlayerLink from './PlayerLink.vue';
import SuspiciousActivityList from './SuspiciousActivityList.vue';

export default {
  name: 'SuspectedPlayersActionTable',

  components: {
    PlayerLink,
    SuspiciousActivityList,
  },

  props: {
    suspectedPlayerContainers: {
      type: Array,
      required: true,
    },

    mayBanPlayer: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    allSelected: {
      get() {
        for(const container of this.suspectedPlayerContainers) {
          if(!container.selected) {
            return false;
          }
        }
        return true;
      },

      set(newValue) {
        if(newValue) {
          this.selectAll();
        } else {
          this.deselectAll();
        }
      },
    },
  },

  methods: {
    convertSuspiciousActivityMaskToList,
    getEventAccessStatusClass,

    selectAll() {
      this.$emit('players-selection-requested');
    },

    deselectAll() {
      this.$emit('players-deselection-requested');
    },

    /** @param {number} playerId */
    banPlayer(playerId) {
      this.$emit('player-ban-requested', playerId);
    },
  },

  filters: {
    getEventAccessStatusName,
  },
}
</script>

<style scoped>
.suspected-players-table {
  width: 1px;
}

.action-box {
  padding: 9px;
  vertical-align: top;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
